import {
    Box,
    Container,
    Grid,
    Skeleton,
    TextField,
    Typography,
    InputAdornment,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import CardSkeleton from './CardSkeleton';

const LMSPageSkeleton = () => {
    return (
        <Container sx={{ py: 4 }}>
            {/* Header */}
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                mb={3}
                gap={2}
            >
                <Skeleton variant="text" width={200} height={35} />
                <Skeleton variant="text" width={300} height={45} />
            </Box>

            <Grid container spacing={3}>
                {/* Left Column - Course Cards Skeletons */}
                <Grid item xs={12} md={9}>
                    <Grid container spacing={3} p={3}>
                        <CardSkeleton />
                    </Grid>
                </Grid>

                {/* Right Column - Certificate Skeleton */}
                <Grid item xs={12} md={3}>
                    <Box
                        sx={{
                            width: 300,
                            p: 3,
                            border: '1px solid #ccc',
                            borderRadius: 1,
                            height: '300px',
                        }}
                    >
                        <Skeleton variant="text" width="60%" height={30} />
                        <Box
                            mt={2}
                            display="flex"
                            flexDirection="column"
                            gap={1}
                        >
                            {[...Array(4)].map((_, idx) => (
                                <Skeleton
                                    key={idx}
                                    variant="rectangular"
                                    height={24}
                                    width="100%"
                                    sx={{ borderRadius: 1 }}
                                />
                            ))}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default LMSPageSkeleton;
